import { Longhand } from "../longhand.js";
import Base from "./top.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/inset-inline-start}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=inset-inline-start.js.map